import { call, put, select, takeLatest } from 'redux-saga/effects'
import { IServiceConfig } from '../../configurations/store/configurations.types'
import { getServiceConfigSelector } from '../../configurations/selectors/serviceConfig.selector'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IPatientDemographicsOptionsState } from '../../options/store/options.types'
import { getPatientDemographicsOptionsSelector } from '../../options/selectors'
import { IOption } from '../../../common/common.types'
import { setWeightUnits, setHeightUnits } from '../store/patientDemographics.actions'
import { getPcrIdSelector } from '../../home/selectors'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { PatientDemographicsConstants } from '../store/patientDemographics.constants'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { IPcr } from '../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../user/selectors/getServiceId.selector'

export function* setPatientDemographicsDefaults() {
  try {
    const pcrID: string = yield select(getPcrIdSelector)

    if (pcrID) {
      const serviceId: string = yield select(getServiceIdSelector)
      const pcrDocsService = new PcrDocsService(serviceId)
      const patientDemographicsOptions: IPatientDemographicsOptionsState = yield select(
        getPatientDemographicsOptionsSelector
      )
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      if (pcrDoc?.patient?.patientDemographics) {
        return
      }

      const serviceConfig: IServiceConfig = yield select(getServiceConfigSelector)
      const { DEFAULT_WEIGHT_MEASUREMENT, DEFAULT_LENGTH_MEASUREMENT } = serviceConfig

      const { weightUnitOptions, heightUnitOptions } = patientDemographicsOptions
      const defaultWeightUnits = weightUnitOptions.find(
        (option: IOption) => option.name?.toString() === DEFAULT_WEIGHT_MEASUREMENT
      )
      const defaultHeightUnits = heightUnitOptions.find(
        (option: IOption) => option.id?.toString() === DEFAULT_LENGTH_MEASUREMENT
      )
      yield put(setWeightUnits(defaultWeightUnits))
      yield put(setHeightUnits(defaultHeightUnits))
    }
  } catch (e) {
    yield put(throwPcrException(`setPatientDemographicsDefaults() error: ${e}`))
  }
}

export function* setPatientDemographicsDefaultsSaga() {
  yield takeLatest(
    [PatientDemographicsConstants.SET_PATIENT_DEMOGRAPHICS_DEFAULTS],
    performWithMutexHOG,
    setPatientDemographicsDefaults
  )
}
